import { ApiException } from "@/domain/core/exception/exceptions"
import { emptyListResponse } from "@/domain/core/utils/django"

const state = {
    certifications: { ...emptyListResponse },
    certification: null,
}

export const getters = {
    certifications: state => state.certifications,
    certification: state => state.certification,
}

export const mutations = {
    certifications(state, certifications) {
        state.certifications = certifications
    },
    certification(state, certification) {
        state.certification = certification
        if (certification && state.certifications.results) {
            state.certifications.results = state.certifications.results.map(c => {
                if (c.id === certification.id) return certification
                return c
            })
        }
    }
}

export const actions = service => ({
    async fetchList({ commit }, { filters, pagination, sorting }) {
        try {
            const certifications = await service.fetchList(filters, pagination, sorting)
            commit('certifications', certifications)
            return certifications
        } catch (e) {
            throw new ApiException(e)
        }
    },

    async fetchDetail({ commit }, id) {
        try {
            const certification = await service.fetchDetail(id)
            commit('certification', certification)
            return certification
        } catch (e) {
            throw new ApiException(e)
        }
    },

    async approve({ commit, dispatch }, id) {
        try {
            const result = await service.approve(id)
            await dispatch('fetchDetail', id)
            return result
        } catch (e) {
            throw new ApiException(e)
        }
    },

    async reject({ commit, dispatch }, { id, rejectedReason }) {
        try {
            const result = await service.reject(id, rejectedReason)
            await dispatch('fetchDetail', id)
            return result
        } catch (e) {
            throw new ApiException(e)
        }
    }
})

export default adminCertificationService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(adminCertificationService)
})
